import React, { useEffect, useState } from "react"
import Input from "@/components/core/Input/Input"
import { useSelector } from "react-redux"
import { selectAuthState } from "@/store/features/authSlice"
import styles from "./contactInformation.module.scss"
import "react-datepicker/dist/react-datepicker.css"
import Button from "@/components/core/Button/Button"
import { getTranslations } from "@/components/Returns/v1/localization"
import { useTranslation, Trans } from "next-i18next"

const ContactInformation = props => {
  const {
    user: { sub: userEmail, firstName = "", lastName = "", login = "" } = {},
  } = useSelector(selectAuthState)
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const handleNext = () => {
    props.onNext()
    props.handleOnNextStep()
  }
  return (
    <div className={styles.contactInfo}>
      {props.status === "edit" ? (
        <>
          <p>
            <Trans
              i18nKey="kf.returns.label.contactRequired"
              values={{ path: props.accountSettingsPath }}
              components={{ anchor: <a /> }}
            />
          </p>
          <div className="contactInfo-fields">
            <div className="row mx-0">
              <div className={`col-12 col-sm-6 col-md-6 pl-0`}>
                <Input
                  id="kf-first-name"
                  type="text"
                  value={firstName}
                  maxLength={60}
                  label="First Name"
                  name="fname"
                  disabled={true}
                />
              </div>
              <div className={`col-12 col-sm-6 col-md-6 pr-0`}>
                <Input
                  id="kf-last-name"
                  type="text"
                  value={lastName}
                  maxLength={60}
                  label={"Last Name"}
                  name="lname"
                  disabled={true}
                />
              </div>
            </div>

            <Input
              id="kf-phone-number"
              type="text"
              value={login}
              maxLength={60}
              label={"Phone Number"}
              name="phone"
              disabled={true}
            />
            <Input
              id="kf-email"
              type="text"
              value={userEmail}
              maxLength={60}
              label={"Email"}
              name="email"
              disabled={true}
            />
          </div>
          <div className="returnitem__nextbutton">
            <Button
              role="button"
              customClass="returnitem__next"
              disabled={false}
              label={staticText.returnNext}
              onClick={handleNext}
            />
          </div>
        </>
      ) : (
        <div className="contactInfo-values">
          <p>{firstName + " " + lastName}</p>
          <p>{login}</p>
          <p>{userEmail}</p>
        </div>
      )}
    </div>
  )
}

export default ContactInformation
